// Types
import { type ISession } from '@/types/session'
// Constants
import { LANGUAGES } from '@/lib/constants/languages'
import * as enLocale from './locales/en'
import * as esLocale from './locales/es'

const TEXTS = {
  [LANGUAGES.ENGLISH]: enLocale,
  [LANGUAGES.SPANISH]: esLocale,
} as const
export type ILanguage = (typeof LANGUAGES)[keyof typeof LANGUAGES]
function isValidLanguage(lang: string): lang is ILanguage {
  return Object.values(LANGUAGES).includes(lang as ILanguage)
}
export function getTexts(lang?: ILanguage): typeof enLocale {
  return TEXTS[lang || LANGUAGES.ENGLISH] as typeof enLocale
}
export type ITranslations = typeof enLocale
const _backofficeOrgInstance = enLocale.BACKOFFICE_ORGANIZATIONS
export type IBackofficeOrganizationsTexts = typeof _backofficeOrgInstance
// The review and maintenance blocks share one shape, so the chip takes whichever it renders.
export type IReviewEntryTexts = typeof enLocale.REVIEW_ENTRIES.REVIEW

export function getTextsFromSession(session: ISession) {
  const language = session.user.language || session.user.organization.language
  return getTexts(language)
}

export function getTextsFromBrowser(navigatorLanguage: string) {
  const browserLang = navigatorLanguage.split('-')[0] || LANGUAGES.ENGLISH
  const isBrowserLangValid = isValidLanguage(browserLang)
  const language = isBrowserLangValid ? browserLang : LANGUAGES.ENGLISH
  return getTexts(language)
}
